import React, {Component} from 'react';
import Lightbox from "react-images";
import i18n from 'i18next';
import moment from "moment";

class SLightbox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentImage: 0,
            lightboxIsOpen: false,
        };

        this.closeLightbox = this.closeLightbox.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
        this.gotoNext = this.gotoNext.bind(this);
        this.gotoPrevious = this.gotoPrevious.bind(this);
    }

    openLightbox(index, event) {
        event.preventDefault();

        this.setState({
            currentImage: index,
            lightboxIsOpen: true,
        });
    }

    closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }

    gotoPrevious() {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    }

    gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }

    render() {
        const {images} = this.props;
        const showMetadata = this.props.showMetadata || false;

        return(
            <>
                <Lightbox
                    key={this.props.key ? this.props.key : Math.random()}
                    images={images.map(image => ({
                        src: image.src || image.url,
                        caption: (
                            <>
                                {showMetadata && image.metadata && (
                                    <div className="exif-info">
                                        <div>
                                            <b className="mr-1">{i18n.t("common:fields.date")}:</b>
                                            {(image.metadata && image.metadata.createdDate) ?
                                                moment(image.metadata.createdDate.date
                                                    ? image.metadata.createdDate.date
                                                    : image.metadata.createdDate
                                                ).format('DD.MM.YYYY HH:mm')
                                                : ''
                                            }
                                        </div>
                                        <div>
                                            <b className="mr-1">{i18n.t("common:fields.gpsInfo")}:</b>
                                            {image.metadata ?
                                                <span> {image.metadata.latitude} {image.metadata.longitude} </span>
                                                : ''
                                            }

                                        </div>
                                        <div>
                                            <b className="mr-1">{i18n.t("common:fields.device")}:</b>
                                            {image.metadata ? <span>{image.metadata.model}</span> : ''}
                                        </div>
                                    </div>
                                )}
                            </>
                        ),
                    }))}
                    onClose={this.closeLightbox}
                    onClickPrev={this.gotoPrevious}
                    onClickNext={this.gotoNext}
                    currentImage={this.state.currentImage}
                    isOpen={this.state.lightboxIsOpen}
                />
            </>
        )
    }
}

export default SLightbox;
